export const getGridColumnsWidths = (image?: string | null) => {
    return image ? [null, 24, null] : [751, null];
};
